import axios from 'axios';
import { getLocale } from '@/helper/i18n-utils';
import { showNotification } from '@/helper/helper';

const url = process.env.VUE_APP_URL;
delete axios.defaults.headers.common['Authorization'];

export const getEmptyFields = async (code, needLang = true) => {
    const path = url + '/doc/journal/indicator/?abc_code=' + code 
        + (needLang ? '&lang=' + getLocale() : '');

    return await axios.get(path, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getEmptyFieldsExternial = async (code, needLang = true) => {
    return await axios.get(url + '/doc/journal/indicator/?abc_code=' + code + (needLang ? '&lang=' + getLocale() : ''))
        .catch(e => showNotification('error', e.response));
};

export const getDictionary = async (code, parentId = null) => {
    const path = url + '/dict/element/?'  
        + (parentId ? 'parent_id=' + parentId + '&' : '')  
        + 'dict_code=' + code;

    return await axios.get(path, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getDirectory = async (name, pageNum = null, params = null) => {
    const path = url + '/doc/' + name +'/' 
    + (pageNum ? '?page=' + pageNum : '') 
    + (params ? params : '');

    return await axios.get(path, { 
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }}
    ).catch(e => showNotification('error', e.response));
};

export const getDirectoryNoToken = async (name, pageNum = null, params = null) => {
    const path = url + '/doc/' + name +'/' 
    + (pageNum ? '?page=' + pageNum : '') 
    + (params ? params : '');

    return await axios.get(path)
        .catch(e => showNotification('error', e.response));
};

export const getDirectoryInfo = async (name, id, needToken = true) => {
    const params = {};
    if (needToken) params.headers = {
        'Authorization': 'Token ' + localStorage.getItem('token')
    }

    return await axios.get(url + '/doc/' + name + '/' + id + '/', params)
        .catch(e => showNotification('error', e.response));
};

export const deleteDirectory = async (name, id) => {
    return await axios.delete(url + '/doc/' + name + '/' + id + '/', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const deleteSomeDirectories = async (name, data) => {
    return await axios.delete(url + '/doc/' + name + '/', { data }, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const deleteDirectoryArray = async (name, data) => {
    return await axios.delete(url + '/doc/' + name + '/', {
        data: data,
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const createDirectory = async (name, data) => {
    return await axios.post(url + '/doc/' + name + '/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const createDirectoryExternial = async (name, data) => {
    return await axios.post(url + '/doc/' + name + '/', data)
        .catch(e => showNotification('error', e.response));
};

export const updateDirectoryById = async (name, id, data) => {
    return await axios.patch(url + '/doc/' + name + '/' + id + '/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const updateDirectoryFormData = async (name, data, file = null) => {
    let formData = new FormData();
    formData.append('data', JSON.stringify(data));
    file    ?   formData.append('file', file)   :   null;

    return await axios.patch(url + '/doc/' + name + '/', formData, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const updateDirectory = async (name, data) => {
    return await axios.patch(url + '/doc/' + name + '/', data, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getFile = async (name, id, params = null) => {
    return await axios.get(url + '/doc/' + name + id + (params ? params : ''), 
        {
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('token'),
            },
            responseType: 'blob'
        }
    ).catch(e => showNotification('error', e.response));
};

export const getContent = async (name) => {
    return await axios.get(url + '/doc/' + name + '/')
        .catch(e => showNotification('error', e.response));
};

export const getDictionaryElements = async (code, pageNum, parentId = null, search = null) => {
    const path = url + '/dict/elements/?abc_code=' + code 
        + ('&page=' + pageNum)  
        + (parentId ? '&parent_id=' + parentId + '&' : '')  
        + (search ? '&search=' + search : '');

    return await axios.get(path, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getDictionaryById = async (elementId) => {
    return await axios.get(url + '/dict/elements/' + elementId + '/', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const createDictionary = async (element) => {
    return await axios.post(url + '/dict/elements/', element, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const updateDictionaryElement = async (element) => {
    return await axios.patch(url + '/dict/elements/' + element.id + '/', element, {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const deleteDictionaryElement = async (id) => {
    return await axios.delete(url + '/dict/elements/' + id + '/', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getDictionaryNoToken = async (code) => {
    return await axios.get(url + '/dict/element/?' + 'dict_code=' + code)
        .catch(e => showNotification('error', e.response));
};

export const getAllDictionaries = async () => {
    return await axios.get(url + '/dict/all/', {
        headers: {
            'Authorization': 'Token ' + localStorage.getItem('token')
        }
    }).catch(e => showNotification('error', e.response));
};

export const getCount = async (params = null) => {
    return await axios.get(url + '/doc/journal/mainpage/' + (params ? params : ''))
        .catch(e => showNotification('error', e.response));
};

export const getStatistic = async (name, params) => {
    return await axios.get(
        url + '/doc/analytics/' + name + '/' + (params ? params : ''), {
            headers: {
                'Authorization': 'Token ' + localStorage.getItem('token')
            }
        }
    ).catch(e => showNotification('error', e.response));
};